import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Layout from "@/components/Layout";
import Home from "@/pages/Home";
import About from "@/pages/About";
import LoginGuide from "@/pages/LoginGuide";
import RegisterGuide from "@/pages/RegisterGuide";
import AlternativeLinks from "@/pages/AlternativeLinks";
import Security from "@/pages/Security";
import Articles from "@/pages/Articles";
import ArticleDetail from "@/pages/ArticleDetail";
import FAQ from "@/pages/FAQ";
import Contact from "@/pages/Contact";
import Admin from "@/pages/Admin";
import NotFound from "@/pages/NotFound";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/admin" element={<Admin />} />
          <Route
            path="*"
            element={
              <Layout>
                <Routes>
                  <Route path="/" element={<Home />} />
                  <Route path="/tentang" element={<About />} />
                  <Route path="/panduan-login" element={<LoginGuide />} />
                  <Route path="/panduan-daftar" element={<RegisterGuide />} />
                  <Route path="/link-alternatif" element={<AlternativeLinks />} />
                  <Route path="/keamanan" element={<Security />} />
                  <Route path="/artikel" element={<Articles />} />
                  <Route path="/artikel/:slug" element={<ArticleDetail />} />
                  <Route path="/faq" element={<FAQ />} />
                  <Route path="/kontak" element={<Contact />} />
                  <Route path="*" element={<NotFound />} />
                </Routes>
              </Layout>
            }
          />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
